export * from "./trust-you.component";
